export default __webpack_public_path__ + "static/media/arrow-dropdown.ce32b834.svg";